import api from "../../../core/api/httpClientInstance";
import API_ENDPOINTS from "../../../core/config/Endpoints";

/**
 * Fetch a CMS-managed static page or site-config value by type.
 * GET /admin-portal/static-page/type/?type=<value>
 *
 * @param {string} type - One of STATIC_PAGE_TYPE (about, faq, privacy, terms,
 *   contact_us, instagram, emails, contact_number, ...).
 * @returns {Promise<{type:string,title:string,content:string}>}
 */
export const getStaticPage = (type) => {
  return api.get(API_ENDPOINTS.STATIC_PAGE(type));
};
